import { FC } from "react";
import moment from "moment";

import { RX_PHONE_NUMBER } from "constants/index";

const Copyright: FC = () => (
  <>
    <div className="-mobile-phone">
      <a href={`tel:${RX_PHONE_NUMBER}`} className="text -footer">
        {RX_PHONE_NUMBER}
      </a>
    </div>
    <div className="-centered-text">
      <p className="text -footer">
        Copyright &copy; {moment().format("YYYY")} Royalty Exchange All Rights
        Reserved.
      </p>
      <address>
        <p className="text -footer">
          1550 Larimer St. #769 Denver, CO 80202 U.S.
        </p>
        <p className="text -footer -desktop-phone">{RX_PHONE_NUMBER}</p>
      </address>
    </div>
  </>
);

export default Copyright;
